// TARGETS
export const targets = {
  Menu_Pedido: "MENU_PEDIDO",
  Menu_RegistroInstalacion: "MENU_REGISTRO_INSTALACION",
  Menu_GarantiaProximaVencer: "MENU_GARANTIA_PROXIMA_VENCER",
  Menu_SolicitudServicio: "MENU_SOLICITUD_SERVICIO",
  Menu_AsociarRemito: "MENU_ASOCIAR_REMITO",
  Menu_FirmarRemito: "MENU_REMITO_DIGITAL",
  Menu_Contacto: "MENU_CONTACTO",
  Menu_Gestion_Noticia: "MENU_GESTION_NOTICIA",
  Menu_Foro: "MENU_FORO",
  Menu_Gestion_Archivo: "MENU_GESTION_ARCHIVO",
  Menu_Perfil: "MENU_PERFIL",
  Menu_Pedidos: "MENU_PEDIDOS",
  Menu_Presupuesto: "MENU_PRESUPUESTO",
  Menu_Presupuestos: "MENU_PRESUPUESTOS",
  Menu_PedidoSubagentes: "MENU_PEDIDOSSUBAGENTES",
  Menu_PedidoADistribuidores: "MENU_PEDIDOSADISTRIBUIDORES",
  Menu_Pendientes: "MENU_PENDIENTES_CUENTA_CORRIENTE",
  Menu_ResumenDeCuenta: 'MENU_RESUMENDECUENTA',
  Menu_Clientes: 'MENU_CLIENTES',
  Menu_2FA: 'MENU_2FA'
}